module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<div class="js-modal-header modal__header">\n    <h3 class="modal__headerTitle">'+
((__t=( options.title ))==null?'':_.escape(__t))+
'</h3>\n\n    <button class="t-modal-close js-modal-cancel modal__close iconParent" type="button">\n        <i class="icon icon-crossRound-midGrey icon-crossRound-midBlue-hover"></i>\n    </button>\n</div>\n\n<div class="js-modal-body modal__body modal__body-wide">\n    <div class="js-component-uploader"></div>\n</div>\n\n<div class="modal__bodyOverflow"></div>\n\n<div class="js-modal-footer modal__footer modal__footer-spacingTop">\n    <div class="modal__footerButtons">\n        <div class="buttonStack">\n            <div class="buttonStack__wrap__button">\n                <button class="js-modal-cancel btn btn-secondary btn-mobile">Cancel</button>\n            </div>\n            <div class="buttonStack__wrap__button">\n                <button class="js-modal-submit btn ';
 if (!options.isSubmitEnabled) { 
__p+='is-disabled';
 } 
__p+='" ';
 if (!options.isSubmitEnabled) { 
__p+='disabled="disabled"';
 } 
__p+=' type="submit">\n                    Post photos\n                </button>\n            </div>\n        </div>\n    </div>\n</div>\n';
}
return __p;
};
